import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Features from '../components/Features';
import Pricing from '../components/Pricing';
import Differentials from '../components/Differentials';
import TargetAudience from '../components/TargetAudience';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <About />
      <Features />
      <Pricing />
      <Differentials />
      <TargetAudience />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Home;